/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCustomerUpdateBase
 */
export interface MstCustomerUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstCustomerUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCustomerUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCustomerUpdateBase
     */
    customerCompanyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    orgCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    customerName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCustomerUpdateBase
     */
    internalTransferFlg?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    customerHojinNo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    customerAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    customerGln?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstCustomerUpdateBase interface.
 */
export function instanceOfMstCustomerUpdateBase(value: object): value is MstCustomerUpdateBase {
    return true;
}

export function MstCustomerUpdateBaseFromJSON(json: any): MstCustomerUpdateBase {
    return MstCustomerUpdateBaseFromJSONTyped(json, false);
}

export function MstCustomerUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCustomerUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'customerCompanyId': json['customer_company_id'] == null ? undefined : json['customer_company_id'],
        'orgCustomerId': json['org_customer_id'] == null ? undefined : json['org_customer_id'],
        'customerName': json['customer_name'] == null ? undefined : json['customer_name'],
        'internalTransferFlg': json['internal_transfer_flg'] == null ? undefined : json['internal_transfer_flg'],
        'customerHojinNo': json['customer_hojin_no'] == null ? undefined : json['customer_hojin_no'],
        'customerAddress': json['customer_address'] == null ? undefined : json['customer_address'],
        'customerGln': json['customer_gln'] == null ? undefined : json['customer_gln'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstCustomerUpdateBaseToJSON(json: any): MstCustomerUpdateBase {
    return MstCustomerUpdateBaseToJSONTyped(json, false);
}

export function MstCustomerUpdateBaseToJSONTyped(value?: MstCustomerUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'customer_company_id': value['customerCompanyId'],
        'org_customer_id': value['orgCustomerId'],
        'customer_name': value['customerName'],
        'internal_transfer_flg': value['internalTransferFlg'],
        'customer_hojin_no': value['customerHojinNo'],
        'customer_address': value['customerAddress'],
        'customer_gln': value['customerGln'],
        'remarks': value['remarks'],
    };
}

